import { Communication } from "neo-games";
import { GameManager } from "../Managers/GameManager";
import { MessageManager } from "../Managers/MessageManager";
import { ReplayService } from "../Replay";

type InitResponse = Communication.Game.InitResponse;

export class SplashScreen {
    //******************************************************************************************************************
    //  SETTINGS
    //******************************************************************************************************************

    private static readonly AutoCloseDelay: number = 15; //in seconds

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static suspendInit: boolean = false;

    private static instance: SplashScreen = null;

    private _htmlInstance: Object;

    private _initResponse: InitResponse;

    private _autoCloseTimerFinished: boolean;

    private _continueEnabled: boolean;

    private _timer: number;

    //******************************************************************************************************************
    //  CREATE & INIT
    //******************************************************************************************************************

    constructor(htmlInstance: Object) {
        if (htmlInstance != null) {
            this._htmlInstance = {};
            this._htmlInstance["instance"] = htmlInstance;

            SplashScreen.suspendInit = true;

            this._autoCloseTimerFinished = false;
            this._continueEnabled = false;

            this._timer = setTimeout(() => {
                this.autoCloseTimer();
            }, SplashScreen.AutoCloseDelay * 1000);
        }
    }

    //******************************************************************************************************************
    //  LOAD (INIT) COMPLETED
    //******************************************************************************************************************

    public onInitReceived(initResponse: InitResponse): void {
        this._initResponse = initResponse;

        //if gameround closed, then show Continue btn, else call onContinue to hide splashscreen
        if (this._initResponse.status != null && this._initResponse.status == Communication.Game.GameStatus.Closed) {
            this.showContinueButton();
        } else {
            this.showGame();
        }
    }

    private autoCloseTimer(): void {
        this._autoCloseTimerFinished = true;

        if (this._continueEnabled) {
            this.showGame();
        }
    }

    private showContinueButton(): void {
        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
            this._continueEnabled = true;

            if (this._autoCloseTimerFinished) {
                this.showGame();
            } else {
                this._htmlInstance["instance"].showContinueButton(this.showGame.bind(this));
            }
        }
    }

    private showGame(): void {
        clearTimeout(this._timer);
        SplashScreen.suspendInit = false;
        MessageManager.postpone(GameManager.continueInitReceived, this._initResponse);
    }

    public hideSplashScreen(): void {
        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
            this._htmlInstance["instance"].hideSplashScreen();
            this._htmlInstance = null;
        }
    }

    public showError(): void {
        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
            this._htmlInstance["instance"].showError();
        }
    }

    //******************************************************************************************************************
    //  PUBLIC HANDLERS
    //******************************************************************************************************************

    public static createSplashScreen(htmlInstance: Object): void {
        if (SplashScreen.instance == null) {
            SplashScreen.instance = new SplashScreen(htmlInstance);
        }
    }

    public static hideSplashScreen(): void {
        if (SplashScreen.instance != null) {
            SplashScreen.instance.hideSplashScreen();
            SplashScreen.instance = null;
        }
    }

    public static suspendInitReceived(initResponse: InitResponse): boolean {
        if (ReplayService.instance.isReplayMode) {
            return false;
        }

        if (SplashScreen.suspendInit && SplashScreen.instance != null) {
            SplashScreen.instance.onInitReceived(initResponse);
            return true;
        }

        return false;
    }

    public static showError(): void {
        if (SplashScreen.instance != null) {
            SplashScreen.instance.showError();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SplashScreen.ts
 **/